import React, { useEffect } from 'react';
import Chart from 'react-apexcharts';

import { ChartWrapper } from '../../../components/Charts/ChartWrapper';
import { useAppSelector } from '../../../../../store';
import { useLazyGetModerationQuery } from '../service/moderation.api';
import { options } from '../utils/chartOptions';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const ModerationChart = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [
        getModeration,
        {
            data: moderation = {
                banned: 0,
                kicked: 0,
                muted: 0,
                violations: 0,
            },
            isFetching,
            isLoading,
        },
    ] = useLazyGetModerationQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: filters.chat || null,
            };

            getModeration(payload, true);
        }
    }, [filters]);

    return (
        <ChartWrapper isLoading={isFetching || isLoading} title='Модерация'>
            <Chart
                height={'200px'}
                type='donut'
                options={options}
                series={[
                    moderation.violations,
                    moderation.muted,
                    moderation.banned,
                    moderation.kicked,
                ]}
            />
        </ChartWrapper>
    );
};
